import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export const CTAButton = ({ 
  href = "#", 
  children = "Réserver mon diagnostic gratuit",
  className = "",
  onClick
}) => {
  const ButtonContent = () => (
    <>
      <span>{children}</span>
      <ArrowRight className="w-5 h-5" />
    </>
  );

  if (onClick) {
    return (
      <motion.button
        data-testid="cta-button"
        onClick={onClick}
        className={`inline-flex items-center justify-center gap-2 bg-[#00A3FF] text-white font-semibold py-3 px-6 rounded-lg text-sm shadow-lg transition-all duration-200 cursor-pointer ${className}`}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        <ButtonContent />
      </motion.button>
    );
  }

  return (
    <motion.a
      data-testid="cta-button"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 bg-[#00A3FF] text-white font-semibold py-3 px-6 rounded-lg text-sm shadow-lg transition-all duration-200 cursor-pointer no-underline ${className}`}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <ButtonContent />
    </motion.a>
  );
};

export default CTAButton;
